import { DateTime } from "luxon";

export function getSortedDeclarationsByEid(a, b) {
  const aEid = parseInt(a.slice(1), 10);
  const bEid = parseInt(b.slice(1), 10);

  return aEid - bEid;
}

export function getSortedDeclarationsByName(a, b) {
  if (a.lastName < b.lastName) return -1;
  if (a.lastName > b.lastName) return 1;

  if (a.shortName < b.shortName) return -1;
  if (a.shortName > b.shortName) return 1;

  const aEid = parseInt(a.eid.slice(1), 10);
  const bEid = parseInt(b.eid.slice(1), 10);

  return aEid - bEid;
}

export function getSortedDeclarationsByDeclaration(a, b) {
  const declarationOrder = ["", "Freeday", "FTO"];
  if (a.declaration === b.declaration) {
    return 0;
  }

  return declarationOrder.indexOf(a.declaration) > declarationOrder.indexOf(b.declaration) ? 1 : -1;
}

export function getSortedDeclarationsByHireDate(a, b) {
  const d1 = DateTime.fromFormat(a, "MM/dd/yyyy");
  const d2 = DateTime.fromFormat(b, "MM/dd/yyyy");

  if(!d1.isValid && !d2.isValid) return 0;
  if(!d1.isValid) return -1;
  if(!d2.isValid) return 1;

  return d1.toMillis() - d2.toMillis();
}
